import React from 'react';
import { Outlet } from 'react-router-dom';

const ReportMngPage = () => {
  return <Outlet />;
};

export default ReportMngPage;
